module.exports = __webpack_public_path__ + "img/chevron-down-circle-outline-red.0613523f.svg";